<template>
  <div id="search">
    <transition-group name="fade01" mode="out-in">
      <el-card class="box-card" v-show="checkTabletPassedToClient" key="cregit-search">
        <div slot="header" class="clearfix">
          <span> <i class="el-icon-bank-card"></i> 会員の方は電話番号と生年月日をご入力ください </span>
        </div>
        <div class="text item">
          <div class="cregit_form">
            <p class="input_error" v-if="input_error">ご入力内容が正しくありません。再度ご確認ください。</p>
            <p class="input_error" v-if="input_error2">
              ご入力された情報からデータが見つかりませんでした。再度ご確認ください。
            </p>
            <p class="input_error" v-if="input_error3">
              現在こちらのカードでのご契約はできません。申し訳ありませんが、（株）トリプルクラウンまでお問い合わせください
            </p>
            <p class="input_error" v-if="input_error4">
              現在こちらのカードでのご契約はできません。申し訳ありませんが、（株）トリプルクラウンまでお問い合わせください
            </p>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-input
                  placeholder="電話番号をご入力"
                  v-model="card_num"
                  @input="
                    cardNumInput()
                    isJust($event, 12, 'card_num_just')
                  "
                  @blur="banCardWord"
                  maxlength="12"
                  type="tel"
                  suffix-icon="el-icon-bank-card"
                ></el-input>
              </el-col>
              <el-col :span="7">
                <el-input
                  placeholder="生年月日の入力"
                  v-model="birthday_num"
                  @input="
                    birthdayNumInput()
                    isJust($event, 8, 'birthday_num_just')
                  "
                  maxlength="8"
                  type="tel"
                ></el-input>
              </el-col>
              <el-col :span="5">
                <div class="button_area">
                  <el-button :loading="loading" @click="start" :disabled="getStart">取得開始</el-button>
                </div>
              </el-col>
            </el-row>

            <p class="input_sample">電話番号のご入力例 必ず11桁以上の数字でご入力ください「08078924512」</p>
            <p class="input_sample">生年月日のご入力例 1986年05月16日生まれの場合「19860516」</p>
            <p class="input_error" v-show="validator.card_num_just">カード番号は必ず12文字入力してください</p>
            <p class="input_error" v-show="validator.card_num_ban_word">
              カード番号のご入力内容が正しくありません。再度ご確認ください。
            </p>
            <p class="input_error" v-show="validator.birthday_num_just">生年月日のは必ず8文字入力してください</p>
          </div>
          <transition name="fade01" mode="out-in">
            <div class="user_data" v-if="user_loaded">
              <table class="table table-bordered">
                <tr>
                  <th colspan="2">名前</th>
                  <td colspan="4">{{ card_name }}({{ card_name_kana }})</td>
                  <th colspan="2">電話番号</th>
                  <td colspan="4">***-****-{{ card_tel }}</td>
                </tr>
                <tr v-if="checkedParson">
                  <th colspan="2">カード上限枠</th>
                  <td colspan="2">{{ card_limit }}</td>
                  <th colspan="2">ご利用残高</th>
                  <td colspan="2">{{ card_remaining }}</td>
                  <th colspan="2">利用可能額</th>
                  <td colspan="2">{{ card_available }}</td>
                </tr>
                <tr v-if="checkedParson">
                  <td colspan="12">
                    <span class="text-danger"
                      >ご購入予定される商品が「利用可能額」を上回る場合は、一度店舗スタッフまでご確認ください。</span
                    >
                  </td>
                </tr>
                <tr v-if="checkedParson">
                  <td colspan="12" class="text-center">
                    <el-checkbox v-model="changePersonal" border :disabled="!check_email"
                      >カードご登録情報を変更依頼</el-checkbox
                    >
                    <br />
                    <template v-if="check_email">
                      <span class="text-danger">カード情報をご変更される場合はこちらにチェックを入れてください。</span>
                    </template>
                    <template v-else>
                      <span class="text-danger"
                        >メールアドレスの情報がありません。カード情報のメールアドレスをご変更ください。</span
                      >
                    </template>
                  </td>
                </tr>
                <tr v-if="checkedParson">
                  <td colspan="12">
                    ご不明な点は下記までお問合せください
                    <br />株式会社トリプルクラウン <br />〒812-0016 <br />福岡県福岡市博多区博多駅南3-1-1
                    博多南マークビル2F <br />電話番号：092-292-7544 <br />平日：9：00～18：00（土・日・祝休）
                  </td>
                </tr>
              </table>
              <div class="checkParson" v-if="!checkedParson">
                お申込者様、ご自身の情報で間違いありませんか？
                <br />宜しければ「 はい 」のボタンを押して詳細をご確認ください
                <el-divider></el-divider>
                <el-button @click="yes">はい</el-button>
                <el-button @click="no">いいえ</el-button>
              </div>
              <div class="choose" v-if="checkedParson">
                <el-button type="primary" @click="addCregit">こちらの顧客の情報に商品を追加する</el-button>
                <!-- <el-button type="primary" v-if="int_card_available > 0" @click="addCregit">こちらの顧客の情報に商品を追加する</el-button> -->
                <!-- <span class="text-danger" v-if="int_card_available <= 0">利用可能額が足りません。（株）トリプルクラウンへお問い合わせ下さい</span> -->
              </div>
            </div>
          </transition>
        </div>
      </el-card>
    </transition-group>
  </div>
</template>

<script>
import {setTimeout, clearTimeout} from 'timers'
import {mapActions, mapGetters} from 'vuex'
import {getFormatPhone} from '../../../util/helper'
import {ActbeValidaterFunctions} from '../../../util/ActbeValidaterFunctions'
import moment from 'moment'
const AVF = new ActbeValidaterFunctions()
export default {
  data() {
    return {
      card_num: '',
      birthday_num: '',
      loading: false,
      user_loaded: false,
      checkTabletPassedToClient: true,
      input_error: false,
      input_error2: false,
      input_error3: false,
      input_error4: false,
      checkedParson: false,
      changePersonal: false,

      porling: null,
      porlingId: 0,

      card_name: '',
      card_name_kana: '',
      card_tel: '',
      card_limit: '',
      card_remaining: '',
      card_available: '',
      int_card_available: 0,

      check_email: false,

      validator: {
        card_num_just: false,
        card_num_is_number: false,
        card_num_ban_word: false,
        birthday_num_just: false,
        birthday_num_is_number: false
      },

      json: ''
    }
  },
  mounted() {
    // if(!this.tel){
    //     this.$router.push({name: 'cregit-sms'})
    // }
  },
  destroyed() {
    // this.porlingId = null;
    // clearTimeout(this.porling);
  },
  methods: {
    start() {
      this.input_error = this.input_error2 = this.input_error3 = this.input_error4 = false
      if (!this.card_num || !this.birthday_num) {
        this.input_error = true
        return
      }
      if (!this.isValidDate(this.birthday_num)) {
        this.input_error = true
        return
      }

      this.loading = true
      setTimeout(() => {
        this.loading = false
        this.user_loaded = true
      }, 500)
      //   axios
      //     .post("/api/store/add/card-search", {
      //       id: this.$store.getters["customer/getId"],
      //       card: this.card_num,
      //       birthday: this.birthday_num
      //     })
      //     .then(res => {
      //       //this.$router.push({name:'cregit-search'})
      //       this.porlingId = res.data.id;
      //       this.startPoling();
      //     })
      //     .catch(err => {
      //       if (err.response.status === 422) {
      //         const errors = err.response.data;
      //         this.error_message = errors["card"][0];
      //       }
      //     });
    },
    isValidDate(strDate) {
      if (!strDate.match(/^\d{8}$/)) {
        return false
      }
      return moment(strDate).isValid()
    },
    startPoling() {
      //会員の検索
      this.porling = setTimeout(() => {
        if (this.porlingId) {
          axios
            .post('/api/store/add/card-searched', {
              id: this.porlingId
            })
            .then((res) => {
              if (res.data.length === 0) {
                this.startPoling()
                return
              }
              let word_masking =
                this.card_num.slice(0, 4) +
                this.card_num.slice(5, 11).replace(/[0-9]/g, '*') +
                this.card_num.slice(12, 16)
              this.card_num = word_masking
              this.porling = null
              if (res.data.error) {
                this.card_num = ''
                this.birthday_num = ''
                this.loading = false
                if (res.data.error == '2') {
                  this.input_error3 = true
                } else if (res.data.error == '3') {
                  this.input_error4 = true
                } else {
                  this.input_error2 = true
                }
              } else {
                this.setData(res.data)
                this.user_loaded = true
              }
            })
            .catch((err) => {
              this.startPoling()
            })
        }
      }, 500)
    },
    setData(data) {
      //会員の持っているデータを表示
      this.card_name = data.name1
      this.card_name_kana = data.name2
      if (data.mobile_phone) {
        this.card_tel = data.mobile_phone
      } else if (data.fixed_phone) {
        this.card_tel = data.fixed_phone
      } else {
        this.card_tel = data.company_phone
      }
      this.card_limit = Number(data.cregit_limit).toLocaleString() + '円'
      this.card_remaining = Number(data.cregit_total_remaining).toLocaleString() + '円'
      this.card_available = Number(data.cregit_available).toLocaleString() + '円'
      this.int_card_available = Number(data.cregit_available)

      this.$store.commit('customer/setLocalId', data.local_customer_id)
      this.$store.commit('product/setBeriFlag', {
        mobile: data.mobile_phone,
        fixed: data.fixed_phone,
        company: data.company_phone
      })
      this.$store.commit('customer/setCheckEmail', data.check_email)
      this.check_email = data.check_email
      if (!this.check_email) {
        this.changePersonal = true
      }

      // 顧客情報のjson
      this.json = JSON.parse(data.details)
      // {
      //   "sex_type": "女性",
      //   "post_number": "544-0003",
      //   "street_address1": "大阪府大阪市生野区小路東",
      //   "street_address2": "マンション 1F",
      //   "fixed_phone": "06-4443-1019",
      //   "mobile_phone": "070-3920-0092",
      //   "email": "test@gmail.com",
      //   "company_name": "株式会社手簀戸",
      //   "company_post": "576-0011",
      //   "company_address1": "東京都墨田区江東橋９９-９９",
      //   "company_address2": "江東橋ビル1F",
      //   "company_phone": "0123-4567-8901",
      //   "company_income": "400"
      // }
    },
    cardNumInput() {
      this.card_num = this.card_num.replace(/[^0-9]/g, '')
    },
    birthdayNumInput() {
      this.birthday_num = this.birthday_num.replace(/[^0-9]/g, '')
    },
    yes() {
      this.checkedParson = true
    },
    no() {
      this.card_num = ''
      this.birthday_num = ''
      this.user_loaded = false
      this.loading = false
    },
    addCregit() {
      //商品の追加に遷移
      //   const name1split = this.card_name.split("　");
      //   const name2split = this.card_name_kana.split("　");

      //   const surname = name1split[0];
      //   const name = name1split[1] ? name1split[1] : "";

      //   const surname_kana = name2split[0];
      //   const name_kana = name2split[1] ? name2split[1] : "";

      //   const tel = this.$store.getters["customer/getTel"];
      //   const formatPhone = getFormatPhone(tel);
      //   const splitPhone = formatPhone.split("-");

      //   const sex_type = this.json.sex_type
      //     ? this.json.sex_type
      //     : null;
      //   const post_number = this.json.post_number
      //     ? this.json.post_number.replace("-", "")
      //     : null;
      //   const street_address1 = this.json.street_address1
      //     ? this.json.street_address1
      //     : null;
      //   const street_address2 = this.json.street_address2
      //     ? this.json.street_address2
      //     : null;
      //   const fixed_phone1 = this.json.fixed_phone
      //     ? this.json.fixed_phone.split("-")[0]
      //     : null;
      //   const fixed_phone2 = this.json.fixed_phone
      //     ? this.json.fixed_phone.split("-")[1]
      //     : null;
      //   const fixed_phone3 = this.json.fixed_phone
      //     ? this.json.fixed_phone.split("-")[2]
      //     : null;
      //   const mobile_phone1 = this.json.mobile_phone
      //     ? this.json.mobile_phone.split("-")[0]
      //     : null;
      //   const mobile_phone2 = this.json.mobile_phone
      //     ? this.json.mobile_phone.split("-")[1]
      //     : null;
      //   const mobile_phone3 = this.json.mobile_phone
      //     ? this.json.mobile_phone.split("-")[2]
      //     : null;
      //   const email = this.json.email ? this.json.email : null;
      //   const company_name = this.json.company_name
      //     ? this.json.company_name
      //     : null;
      //   const company_post = this.json.company_post
      //     ? this.json.company_post.replace("-", "")
      //     : null;
      //   const company_address1 = this.json.company_address1
      //     ? this.json.company_address1
      //     : null;
      //   const company_address2 = this.json.company_address2
      //     ? this.json.company_address2
      //     : null;
      //   const company_phone1 = this.json.company_phone
      //     ? this.json.company_phone.split("-")[0]
      //     : null;
      //   const company_phone2 = this.json.company_phone
      //     ? this.json.company_phone.split("-")[1]
      //     : null;
      //   const company_phone3 = this.json.company_phone
      //     ? this.json.company_phone.split("-")[2]
      //     : null;
      //   const company_income = this.json.company_income
      //     ? this.json.company_income
      //     : null;

      //   this.$store.commit("product/hasCustommer", this.changePersonal);

      //   if (this.changePersonal) {
      //     this.transitionSame('card-change-personal');
      //   } else {
      //     this.transitionSame('cregit-pass-staff');
      //   }

      this.$emit('next')
    },
    isJust(e, just, validator) {
      if (e) {
        let num = e.length
        this.validator[validator] = AVF.IsJust(num, just) ? true : false
      }
    },
    banCardWord(e) {
      return false
      // const first = (e.srcElement.value) ? e.srcElement.value.split('')[0] : '';
      // const regex = /[7]/g;
      // this.validator.card_num_ban_word = AVF.BanWord(first, regex);
    },
    ...mapActions({})
  },
  computed: {
    getStart() {
      return this.card_num && this.birthday_num
        ? !this.validator.card_num_just && !this.validator.birthday_num_just && !this.validator.card_num_ban_word
          ? false
          : true
        : true
    },
    ...mapGetters({
      tel: 'customer/getTel'
    })
  }
}
</script>

<style lang="scss" scoped>
.message_area {
  padding: 15px;
  border: 2px solid #eee;
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  margin-left: 15px;
  margin-right: 15px;
}
.cregit_form {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}
.input_sample {
  margin: 5px 0;
  font-size: 12px;
  color: salmon;
}
.input_error {
  margin-bottom: 5px;
  font-size: 12px;
  color: red;
}
.button_area {
  .el-button {
    width: 100%;
  }
}

.user_data {
  margin-top: 20px;
  border-top: 1px solid #ebeef5;
  padding-top: 20px;

  .table-bordered {
    border-size: 2px;
  }

  .choose {
    text-align: center;
  }
  .checkParson {
    margin-top: 10px;
    text-align: center;
  }
}
</style>
